module.exports = __webpack_public_path__ + "static/media/AKC3.e2714632.png";